const ufeApi = require('services/api/ufeApi');
const jsUtils = require('utils/javascript');
const localeUtils = require('utils/LanguageLocale');
const urlUtils = require('utils/Url');
const experiencesApiBase = '/v1/olr/activities';

/* eslint-disable max-len */
// API documentation: https://stage-developer.sephora.com/specs/v1/docs/store.html#get-activities-for-stores
/* eslint-enable max-len */

function getExperiences(token, params) {
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    const paramsWithValue = JSON.parse(JSON.stringify(params));
    const url = sdnDomain + experiencesApiBase +
        (params.activityId ? '/' + params.activityId : '') +
        urlUtils.buildQuery(jsUtils.buildMap(paramsWithValue));
    return ufeApi.makeRequest(url, {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + token,
            'site_locale': localeUtils.getCurrentCountry()
        },
        mode: 'cors',
        credentials: 'omit'
    })
        .then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getExperiences;
